/* src/app/common/mpos-forms/components/mpos-date/mpos-date.component.scss */
:host {
  display: flex;
}
:host nz-form-item {
  display: flex;
  width: 100%;
}
:host .ant-calendar-picker {
  width: 100% !important;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1mb3Jtcy9jb21wb25lbnRzL21wb3MtZGF0ZS9tcG9zLWRhdGUuY29tcG9uZW50LnNjc3MiXSwKICAic291cmNlc0NvbnRlbnQiOiBbIjpob3N0IHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIC8vIGZsZXg6IDEgMCAwJTtcbiAgICAvLyBwYWRkaW5nLWxlZnQ6IDRweDtcbiAgICAvLyBwYWRkaW5nLXJpZ2h0OiA0cHg7XG5cbiAgICAvLyAuYW50LWZvcm0taXRlbS1sYWJlbCB7XG4gICAgLy8gICAgIGxpbmUtaGVpZ2h0OiAycmVtICFpbXBvcnRhbnQ7XG4gICAgLy8gICAgIG1hcmdpbjogMCAwIDAgIWltcG9ydGFudDtcbiAgICAvLyB9XG4gICAgbnotZm9ybS1pdGVtIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgfVxuICAgIC5hbnQtY2FsZW5kYXItcGlja2VyIHtcbiAgICAgICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgICB9XG59XG4iXSwKICAibWFwcGluZ3MiOiAiO0FBQUE7QUFDSSxXQUFBOztBQVNBLE1BQUE7QUFDSSxXQUFBO0FBQ0EsU0FBQTs7QUFFSixNQUFBLENBQUE7QUFDSSxTQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
